import { render, staticRenderFns } from "./zxxjTable.vue?vue&type=template&id=1298b9ab&scoped=true"
import script from "./zxxjTable.vue?vue&type=script&lang=js"
export * from "./zxxjTable.vue?vue&type=script&lang=js"
import style0 from "./zxxjTable.vue?vue&type=style&index=0&id=1298b9ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298b9ab",
  null
  
)

export default component.exports